import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ApplicationsService } from '../services/applications.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class ApplicationListResolver implements Resolve<Observable<string>> {

    constructor(private versionsService: ApplicationsService) { }

    resolve() {
        return this.versionsService.getApplications().catch(() => {
            return Observable.of('error');
        });
    }
}
